<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('edit')}} {{t('asset')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Masters')}}
            </li>
            <li class="breadcrumb-item position-relative">
                <a routerLink="/masters/assets" class="d-inline-block position-relative">
                    {{t('Assets')}}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('edit')}} {{t('asset')}}
            </li>
        </ol>
    </div>

    <!-- Create Asset -->
    <mat-card class="altair-card create-company-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-content>
            <form [formGroup]="editAssetForm" (ngSubmit)="onSubmit()">
                <div class="row">
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('name')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-name')}}
                                </mat-label>
                                <input matInput type="text" id="name" formControlName="name"
                                    [(ngModel)]="editAsset.name" required>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('location')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-location')}}
                                </mat-label>
                                <input matInput type="text" id="location" formControlName="location"
                                    [(ngModel)]="editAsset.location">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('operating-system')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-operating-system')}}
                                </mat-label>
                                <input matInput type="text" id="operatingSystem" formControlName="operatingSystem"
                                    [(ngModel)]="editAsset.operatingSystem">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('evaluable')}}
                            </label>
                            <mat-card-content>
                                <mat-checkbox id="evaluable" formControlName="evaluable"
                                    [(ngModel)]="editAsset.evaluable">{{t('evaluable')}}</mat-checkbox>
                            </mat-card-content>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('assetType')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-asset-type')}}
                                </mat-label>
                                <mat-select formControlName="assetType" [(value)]="selectedAssetType">
                                    <mat-option *ngFor="let type of types" [value]="type">
                                        {{type}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('status')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-status')}}
                                </mat-label>
                                <mat-select formControlName="assetVerificationStatus" [(value)]="selectedStatus"
                                    required>
                                    <mat-option *ngFor="let status of statusList" [value]="status">
                                        {{status.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('company')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-company')}}
                                </mat-label>
                                <mat-select [(value)]="selectedCompany"
                                    (selectionChange)="changeCompany(selectedCompany)" required>
                                    <mat-option *ngFor="let company of companies" [value]="company.id">
                                        {{company.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('brand')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-brand')}}
                                </mat-label>
                                <mat-select formControlName="brand" [(value)]="selectedBrand">
                                    <mat-option *ngFor="let brand of brands" [value]="brand">
                                        {{brand.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('branch-office')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-branch-office')}}
                                </mat-label>
                                <mat-select formControlName="branchOffice" [(value)]="selectedBranchOffice">
                                    <mat-option *ngFor="let branchOffice of branchOffices" [value]="branchOffice">
                                        {{branchOffice.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('ip')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-ip')}}
                                </mat-label>
                                <input matInput type="text" id="ip" formControlName="ip" [(ngModel)]="editAsset.ip">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('port')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-port')}}
                                </mat-label>
                                <input matInput type="number" id="port" formControlName="port"
                                    (keydown.e)="onKeydown($event)" [(ngModel)]="editAsset.port">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <button mat-button type="submit" [disabled]="editAssetForm.invalid">
                        {{t('save')}} {{t('asset')}}
                    </button>
                    <a mat-button routerLink="/masters/assets">
                        {{t('cancel')}}
                    </a>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-container>
